export default __webpack_public_path__ + "static/media/bernard_tung.e11f2fcb.png";